import $ from 'jquery';

export class Messages {
  constructor() {
    this.listeners = {};
    this.listenersAll = [];
    this.once = [];
  }

  subscribe(type, listener) {
    const types = type.split(" ");
    for (const type of types) {
      this.listeners[type] = (!this.listeners[type]) ? [] : this.listeners[type];
      this.listeners[type].push(listener);
    }
  }

  subscribeAll(listener) {
    this.listenersAll.push(listener);
  }

  unsubscribe(type, listener) {
    if (this.listeners[type]) {
      if (!listener) {
        delete this.listeners[type];
      } else {
        for (let i = 0; i < this.listeners[type].length; i++) {
          delete this.listeners[type][i];
        }
      }
    }
  }

  send(action) {
    if (this.listeners[action.type]) {
      for (let listener of this.listeners[action.type]) {
        if (!listener) continue;
        listener(action);
        if(this.once.indexOf(listener) !== -1) {
          this.unsubscribe(action.type, listener);
          delete this.once[this.once.indexOf(listener)];
        }
      }
    }
    for (let listener of this.listenersAll) {
      listener(action);
    }
  }

  on(type, listener) {
    this.subscribe(type, listener);
  }

  one(type, listener) {
    this.once.push(listener);
    this.subscribe(type, listener);
  }
}

$.messages = new Messages();



/** WEBPACK FOOTER **
 ** ../assets/js/messages.js
 **/